import {
    ATTRIBUTES,
    getBisProvider,
    openBackInStockModal,
    PUB_SUB_EVENTS,
    SELECTORS,
    createATCitems
} from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { publish } from '@/scripts/core/global'
import { QuickAddModal } from '@/scripts/optional/quick-add'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { applyStoqPreorderProperties } from '@/scripts/product/stoq-selling-plan'
import {
    addItemsToCart,
    getCartAttributesFromFormData,
    getDOMCartSectionApiIds, hasDomCart,
    renderResponseToCartDrawer
} from '@/scripts/core/cart-functions';
import { CartErrorResponse } from '@/scripts/shopify'

export class QuickAddForm extends UcoastEl {
    static htmlSelector = 'quick-add-form'
    static selectors = {
        form: 'form',
        formIdEl: '[name=id]',
        submitButton: '.quick-add-form__submit',
        variantPickerEl: '.variant-picker',
        sizeLabel: '.size-label',
        variantDropdownClose: '.variant-dropdown__close',
        variantGenderLabel: '.variant-dropdown__gender-label',
        variantItemButton: '.variant-dropdown__item-button',
        cardWrapper: '.card-wrapper'
    }

    cardWrapper: HTMLElement
    form: HTMLFormElement
    formIdEl: HTMLInputElement
    submitButton: HTMLButtonElement
    variantPickerEl: HTMLElement
    sizeLabel: HTMLButtonElement
    variantDropdownClose: HTMLElement
    variantGenderLabels: NodeListOf<HTMLButtonElement>
    variantItemButtons: NodeListOf<HTMLButtonElement>
    hideErrors: boolean
    error?: boolean

    constructor() {
        super()

        this.form = q.rs(QuickAddForm.selectors.form, this)
        this.formIdEl = (this.form.querySelector('[name="id"]') as HTMLInputElement) || (this.form.querySelector('[name="items[0][id]"]') as HTMLInputElement)
        this.variantPickerEl = q.rs(QuickAddForm.selectors.variantPickerEl, this.form)
        this.sizeLabel = q.rs(QuickAddForm.selectors.sizeLabel, this)
        this.variantDropdownClose = q.rs(QuickAddForm.selectors.variantDropdownClose, this)
        this.variantGenderLabels = q.rl(QuickAddForm.selectors.variantGenderLabel, this)
        this.variantItemButtons = this.querySelectorAll(QuickAddForm.selectors.variantItemButton)

        this.sizeLabel.addEventListener('click', this.toggleDropdown.bind(this))
        this.variantDropdownClose.addEventListener('click', this.closeDropdown.bind(this))
        
        this.variantItemButtons.forEach(button => {
            button.addEventListener('click', this.onClickItem.bind(this))
        })
        this.variantGenderLabels.forEach(button => {
            button.addEventListener('click', this.onClickGenderLabel.bind(this))
        })

        this.submitButton = q.rs(QuickAddForm.selectors.submitButton, this)
        if (hasDomCart()) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog')
        }
		// If variant id input is disabled (multi-variant without selection), prevent submit at start
		if (this.formIdEl?.disabled) {
			this.submitButton.disabled = true
		}
		// Handle clicks for OOS notify flow to avoid form submission
		this.submitButton.addEventListener('click', this.onClickSubmit.bind(this))

        this.hideErrors = this.dataset.hideErrors === 'true'

        this.cardWrapper = q.rc(this, QuickAddForm.selectors.cardWrapper)
        if(this.cardWrapper) this.cardWrapper.addEventListener('mouseleave', this.closeDropdown.bind(this))
    }

	onClickSubmit(e: Event) {
        e.preventDefault()
		const bisVariantId = q.oa(this.submitButton, 'data-uc-bis-variant-id')
		const oosUrl = q.oa(this.submitButton, 'data-oos-popup-trigger')
		if (!bisVariantId) {
            this.onSubmitHandler(e)
        }
		else {
		    openBackInStockModal({
				opener: this.submitButton,
				klaviyoUrl: oosUrl,
				variantId: bisVariantId,
			})
        }
	}

    toggleDropdown(e: Event) {
        e.preventDefault()
        this.variantPickerEl.classList.toggle('active')
    }

    openDropdown(e: Event) {
        e.preventDefault()
        this.variantPickerEl.classList.add('active')
    }

    closeDropdown(e: Event) {
        e.preventDefault()
        this.variantPickerEl.classList.remove('active')
    }

    onClickItem(e: Event) {
        e.preventDefault()
        this.variantPickerEl.classList.remove('active')
		this.submitButton.disabled = false
        const target = e.currentTarget as HTMLButtonElement
        this.variantItemButtons.forEach(item => {
            item.classList.remove('active')
        })
        target.classList.add('active')

        const variantId = target.dataset.variantId
        const available = target.dataset.available == "true"
        const inventoryStatus = target.dataset.inventoryStatus || ''
        if(!variantId) return
        this.formIdEl.value = variantId

        const size = target.dataset.size
        const sizeLabelTextWrapper = q.rs('.size-label-text', this.sizeLabel)
        if(!size || !sizeLabelTextWrapper) return
        sizeLabelTextWrapper.textContent = size

        const atcText = this.submitButton.dataset.atcText
        const soldoutText = this.submitButton.dataset.soldoutText
        const preorderText = this.submitButton.dataset.preorderText
        const inventoryStatusTextEl = q.rs('[data-uc-inventory-status-text]', this.submitButton)
        if(!atcText || !soldoutText || !preorderText || !inventoryStatusTextEl) return

		if(available) {
			this.formIdEl.disabled = false
			this.submitButton.type = 'submit'
            this.submitButton.removeAttribute('data-oos-popup-trigger')
            this.submitButton.removeAttribute('data-uc-bis-variant-id')
            this.submitButton.dataset.preorder = inventoryStatus === 'PreOrder' ? 'true' : 'false'
            this.submitButton.dataset.inventoryStatus = inventoryStatus
            inventoryStatusTextEl.textContent = inventoryStatus === 'PreOrder' ? preorderText : atcText
		} else {
			// Keep variant id disabled to avoid accidental ATC
			this.formIdEl.disabled = true
			// Prevent form submission, rely on click handler to open waitlist modal
			this.submitButton.type = 'button'
            this.submitButton.setAttribute('data-uc-bis-variant-id', variantId)
            if (getBisProvider(this.submitButton) === 'klaviyo') {
                this.submitButton.setAttribute('data-oos-popup-trigger', `${this.dataset.url}?variant=${variantId}&section_id=waitlist`)
            } else {
                this.submitButton.removeAttribute('data-oos-popup-trigger')
            }
            this.submitButton.dataset.preorder = 'false'
            this.submitButton.dataset.inventoryStatus = inventoryStatus
            inventoryStatusTextEl.textContent =
                inventoryStatus === 'ComingSoon'
                    ? target.dataset.inventoryStatusText || soldoutText
                    : soldoutText
        }
    }

    onClickGenderLabel(e: Event) {
        e.preventDefault()
        this.variantGenderLabels.forEach(label => {
            label.classList.remove('active')
        })
        const target = e.currentTarget as HTMLElement
        if(!target) return
        target.classList.add('active')
        const gender = target.dataset.gender
        
        this.variantItemButtons.forEach(button => {
            q.rl('.variant-dropdown__item-text', button).forEach(text => {
                text.classList.toggle('hidden', text.dataset.gender != gender)
            })
        })
    }

    getSpinner() {
        return q.rs(SELECTORS.loadingOverlaySpinner, this)
    }

    onSubmitHandler(event: Event) {
        this.closeDropdown(event)
        if(this.formIdEl.disabled) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return
        const bisVariantId = q.oa(this.submitButton, 'data-uc-bis-variant-id')
        const oosUrl = q.oa(this.submitButton, 'data-oos-popup-trigger')
        if (bisVariantId) {
            openBackInStockModal({
                opener: this.submitButton,
                klaviyoUrl: oosUrl,
                variantId: bisVariantId,
            })
            return
        }
        const preorder = this.submitButton.dataset.preorder == 'true'

        this.submitButton.setAttribute('aria-disabled', 'true')
        this.submitButton.setAttribute(ATTRIBUTES.loading, '')
        this.getSpinner().classList.remove('hidden')

        const formData = new FormData(this.form)
        let formVariantId = formData.get('id') || formData.get('items[0][id]')
        if (!formVariantId) throw Error('No variant id found')
        const addedVariantId = parseInt(formVariantId.toString())
        
        type AddToCartItem = {
            id: number
            quantity: number
            selling_plan?: number
            properties: Record<string, string>
            parent_id?: number
        }
        let items: AddToCartItem[] = []
        if(formData.get('items[0][id]')) {
            applyStoqPreorderProperties({
                formData,
                preorder,
            })
            items = createATCitems(formData) as AddToCartItem[]
        } else {
            applyStoqPreorderProperties({
                formData,
                preorder,
            })
        }
        const cartAttributes = getCartAttributesFromFormData(formData)

        addItemsToCart(
            items.length ? items : formData,
            getDOMCartSectionApiIds(),
            cartAttributes
        )
            .then((cart) => {
                if ('status' in cart) {
                    return
                }

                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: addedVariantId,
                })
                renderResponseToCartDrawer(cart)
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {
                this.submitButton.removeAttribute(ATTRIBUTES.loading)

                if (!this.error)
                    this.submitButton.removeAttribute('aria-disabled')
                this.getSpinner().classList.add('hidden')
            })
    }
}
